import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import Header from "./components/header";
import Footer from "./components/footer";
import './App.css';

import Home from './pages/Home';
import Gruppenangebote from './pages/Gruppenangebote';
import Ueber from './pages/Ueber';
import Referenzen from './pages/Referenzen';
import Galerie from './pages/Galerie';
import Kontakt from './pages/Kontakt';
import Links from './pages/Links';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

function App() {
    return <Router>

      <ScrollToTop />

      <Header />

      

      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/gruppenangebote" component={Gruppenangebote} />
        <Route path="/ueber" component={Ueber} />
        <Route path="/referenzen" component={Referenzen} />
        <Route path="/galerie" component={Galerie} />
        <Route path="/kontakt" component={Kontakt} />
        <Route path="/links" component={Links} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/datenschutz" component={Datenschutz} />
        <Redirect to="/" />
      </Switch>

      <Footer />

      <BackToTop />

    </Router>;
}

export default App;
